module.exports = __webpack_public_path__ + "static/mrcs-demo-web-1-414c0331bf3f947343762a0573d90081.jpg";